import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from "./AuthSlice";
import toastReducer from "./ToastSlice";
import CoreSlice from './CoreSlice';
import ConfirmationSlice from './ConfirmationSlice';
import loaderSlice from "./LoaderSlice";

const store = configureStore({
    reducer: {
        auth : authReducer,
        toast : toastReducer,
        core : CoreSlice,
        confirmation : ConfirmationSlice,
        loader : loaderSlice
    },
});

export default store;